import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlogCTAButtons from "@/components/BlogCTAButtons";
import CanonicalTag from "@/components/CanonicalTag";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import heroImage from "@/assets/modern-adu-flat-roof-design.png";

const BlogFlatRoofDesign = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": "Modern ADUs With Flat Roof Design",
    "description": "Clean lines, large windows, and open interiors. Learn about flat roof ADU design and what it takes to build one right.",
    "datePublished": "2026-04-09",
    "author": { "@type": "Organization", "name": "UDA ADU" },
    "publisher": { "@type": "Organization", "name": "UDA ADU" },
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/blogs/modern-adu-flat-roof-design" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Navigation />
      <div className="w-full max-w-5xl mx-auto px-4 pt-8">
        <img src={heroImage} alt="Modern ADU with flat roof design" className="w-full rounded-2xl" />
      </div>
      <main className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/blogs" className="inline-flex items-center text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4 mr-2" /> Back to Blog
        </Link>
        <p className="text-sm text-muted-foreground mb-2">April 9, 2026</p>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">Modern ADUs With Flat Roof Design</h1>
        <article className="prose prose-lg max-w-none text-muted-foreground space-y-6">
          <p>Flat roof ADUs have become more common, especially for homeowners looking for a modern look.</p>
          <p>They allow for clean lines, large windows, and open interiors.</p>
          <p>But they also require proper planning. Drainage, structure, and materials need to be handled correctly.</p>
          <p>We design these systems from the beginning so there are no issues later.</p>
          <p>Modern design works best when it's built right.</p>
        </article>
        <BlogCTAButtons />
      </main>
      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default BlogFlatRoofDesign;
